module.exports = __webpack_public_path__ + "static/car5-bfda2517c3b151a7be2c8581b77ecbc9.png";